const getCampaignName = (): string => {
  const hrefUrl = window.location.href;
  let campaignName;
  if (hrefUrl.includes("?")) {
    campaignName = hrefUrl;
    campaignName && sessionStorage.setItem("campaignName", campaignName);
  }
  return campaignName;
};

const UtmCampaign = (): string => {
  const utmParams = [
    "campaign",
    "source",
    "medium",
    "term",
    "content",
    "device",
  ];

  try {
    const url = new URL(window.location.href);
    const utmData = utmParams.reduce(
      (obj, key) => {
        const value = url.searchParams.get(`utm_${key}`);
        if (value) {
          obj[`Marketing${key.charAt(0).toUpperCase() + key.slice(1)}`] = value;
        }
        return obj;
      },
      {} as { [key: string]: string },
    );

    if (Object.keys(utmData)?.length > 0) {
      const leadAdditionalNoteLabel = Object.entries(utmData)
        .map(([key, value]) => `${key}: ${value}`)
        .join(", ");
      return leadAdditionalNoteLabel;
    } else {
      const campaign = sessionStorage.getItem("campaignName");
      if (campaign) {
        const campaignParams = new URLSearchParams(campaign);
        const leadAdditionalNoteLabel = utmParams
          .map((key) => {
            const value = campaignParams.get(`utm_${key}`);
            return value ? `Marketing${key}: ${value}` : null;
          })
          .filter(Boolean)
          .join(", ");
        return leadAdditionalNoteLabel;
      }
    }
  } catch (e) {
    console.error("Error parsing UTM parameters:", e);
    return "";
  }
  return "";
};

export { UtmCampaign, getCampaignName };
